import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'
import store from '@/store'
import { maxTabs } from '@/config'

Vue.use(VueRouter)

export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: '/index',
        name: 'Index',
        component: () => import('@/views/Index.vue'),
        meta: { title: '首页', affix: true },
      },
    ],
    meta: { title: '首页', hidden: true },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录', hidden: true },
  },
  {
    path: '/',
    name: 'LoginLog',
    component: Layout,
    meta: { title: '权限控制', hidden: false },
    children: [
      {
        path: '/adminLoginLog',
        name: 'AdminLoginLogList',
        component: () => import('@/views/loginLog/adminList.vue'),
        meta: { title: '管理员登录日志', hidden: false },
      },
      {
        path: '/conservatorList',
        name: 'conservatorList',
        component: () => import('@/views/loginLog/conservatorList/index'),
        meta: { title: '管理员列表', hidden: false },
      },
    ],
  },
  {
    path: '/sessionManagement',
    name: 'sessionManagement',
    component: Layout,
    meta: { title: '会话管理', hidden: false },
    children: [
      {
        path: '/loginLog',
        name: 'LoginLogList',
        component: () => import('@/views/sessionManagement/onlineUsers/index'),
        meta: { title: '在线用户', hidden: false },
      },
    ],
  },
  {
    path: '/appManagement',
    name: 'appManagement',
    component: Layout,
    meta: { title: '应用管理', hidden: false },
    children: [
      {
        path: '/appList',
        name: 'appList',
        component: () => import('@/views/appManagement/appList/index'),
        meta: { title: '应用列表', hidden: false },
      },
      {
        path: '/accessAuth',
        name: 'accessAuth',
        component: () => import('@/views/appManagement/accessAuth/index'),
        meta: { title: '访问授权', hidden: false },
      },
    ],
  },
  {
    path: '/userManagement',
    name: 'userManagement',
    component: Layout,
    meta: { title: '用户管理', hidden: false },
    children: [
      {
        path: '/userList',
        name: 'userList',
        component: () => import('@/views/userManagement/userList/index'),
        meta: { title: '用户列表', hidden: false },
      },
      {
        path: '/userLoginLog',
        name: 'LoginLogList',
        component: () => import('@/views/loginLog/list.vue'),
        meta: { title: '用户登录日志', hidden: false },
      },
      {
        path: '/userAccountList',
        name: 'UserAccountList',
        component: () => import('@/views/userManagement/userAccount/index'),
        meta: { title: '子账号管理', hidden: false },
      },
    ],
  },
  {
    path: '/organization',
    name: 'organization',
    component: Layout,
    meta: { title: '组织管理', hidden: false },
    children: [
      {
        path: '/organizationList',
        name: 'organizationList',
        component: () => import('@/views/organization/organizationList/index'),
        meta: { title: '组织列表', hidden: false },
      },
    ],
  },
  {
    path: '/roleManagement',
    name: 'roleManagement',
    component: Layout,
    meta: { title: '角色管理', hidden: false },
    children: [
      {
        path: '/role',
        name: 'role',
        component: () => import('@/views/roleManagement/role/index'),
        meta: { title: '角色管理', hidden: false },
      },
    ],
  },
  {
    path: '/configManagement',
    name: 'configManagement',
    component: Layout,
    meta: { title: '配置管理', hidden: false },
    children: [
      {
        path: '/config',
        name: 'Config',
        component: () => import('@/views/configManagement/config/index'),
        meta: { title: '全局配置', hidden: false },
      },
    ],
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue'),
    meta: { title: '404', hidden: true },
  },
  {
    path: '/401',
    name: '401',
    component: () => import('@/views/401.vue'),
    meta: { title: '401', hidden: true },
  },
  {
    path: '*',
    redirect: '404',
    meta: { title: 'not Found', hidden: true },
  },
]

// 开发环境下，添加一些本地用于模拟测试的路由
// if (process.env.NODE_ENV === 'development') {
//   const mockRoutes = require('../../test/routes.js').default
//   constantRoutes.push(...mockRoutes)
// }

function createRouter() {
  return new VueRouter({
    routes: constantRoutes,
  })
}

const router = createRouter()

export function resetRouter() {
  router.matcher = createRouter().matcher
}

const originalPush = router.push
router.push = function (...args) {
  const location = this.match(args[0])
  const visiteRoutes = store.getters['tabsBar/visiteRoutes']
  const target = visiteRoutes.find((item) => item.path === location.path)
  if (!target && visiteRoutes?.length > maxTabs) {
    const message = `最多只能打开${maxTabs + 1}个页面，请先关闭部分页面。是否关闭前五个页面？`
    Vue.prototype
      .$mgAlert(message, '提示', { confirmButtonText: '关闭并打开新页面' })
      .then(() => {
        const changePages = store.getters['tabsBar/changePages']
        if (visiteRoutes.some((item) => changePages.includes(item?.name))) {
          return Vue.prototype.$mgConfirm('当前页面正在编辑，确认关闭?')
        }
      })
      .then(() => {
        visiteRoutes.slice(1, 5).forEach((route) => store.dispatch('tabsBar/removeTab', route))
        originalPush.call(this, ...args)?.catch(() => {})
      })
    return
  }
  return originalPush.call(this, ...args)?.catch(() => {})
}

export default router
